import { type ActionReducerMapBuilder, createAction } from '@reduxjs/toolkit';

import { workspaceApi } from '@/api/workspace/index.ts';
import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { shareCurrentTab } from '@/store/sharedWorkspace/shareCurrentTab.ts';
import { tabsAdapter } from '@/store/tabs/adapter.ts';
import type { TabsState } from '@/store/tabs/types.ts';
import { saveWorkspace } from '@/store/workspace/saveWorkspace.ts';

//////////////////////////////////////
// user click on button "share tab" //
//////////////////////////////////////
export const onClickShareTab = createAction<{ users: string[]; ownerEmail: string }>('onClickShareTab');

/////////////////////////////////////////////////////////////////////////////////////////
// in tab slice, on user click "share tab", flag the tab as shared (optimistic update) //
/////////////////////////////////////////////////////////////////////////////////////////
export function reduceOnClickShareTab(builder: ActionReducerMapBuilder<TabsState>) {
  builder.addMatcher(workspaceApi.endpoints.shareTab.matchFulfilled, (state, action) => {
    tabsAdapter.updateOne(state.tabs, {
      id: state.activeTabId,
      changes: {
        sharedWithUsers: action.meta.arg.originalArgs.sharedWithEmails,
        isShared: true,
        ownerEmail: action.meta.arg.originalArgs.ownerEmail,
      },
    });
  });
}

/////////////////////////////////////////////////////////////////////////////////////
// on user click "share tab", trigger http request to share tab AND save workspace //
/////////////////////////////////////////////////////////////////////////////////////
export function registerShareTabListener(startAppListening: StartAppListening) {
  startAppListening({
    actionCreator: onClickShareTab,
    effect: async (action, { getState, dispatch }) => {
      //////////////////////////
      // POST share workspace //
      //////////////////////////
      const shareResult = await shareCurrentTab({
        ownerEmail: action.payload.ownerEmail,
        users: action.payload.users,
        getState,
        dispatch,
      });

      /////////////////////////
      // POST save workspace //
      /////////////////////////
      // save workspace on post new shared tab, not on save shared tab
      if (shareResult && !shareResult.error) {
        saveWorkspace({ getState, dispatch });
      }
    },
  });
}
